import { render, staticRenderFns } from "./ProvidersTable.vue?vue&type=template&id=9a3eebe2&scoped=true"
import script from "./ProvidersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProvidersTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProvidersTable.vue?vue&type=style&index=0&id=9a3eebe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3eebe2",
  null
  
)

export default component.exports